import admin from "./admin.yml";
import billing from "./billing.yml";
import brokerSearch from "./broker-search.yml";
import cabin from "./cabin.yml";
import common from "./common.yml";
import company from "./company.yml";
import email from "./email.yml";
import error from "./error.yml";
import file from "./file.yml";
import fleet from "./fleet.yml";
import form from "./form.yml";
import image from "./image.yml";
import itineraryLocation from "./itinerary-location.yml";
import itineraryTemplate from "./itinerary-template.yml";
import location from "./location.yml";
import nav from "./nav.yml";
import offer from "./offer.yml";
import place from "./place.yml";
import proposalYacht from "./proposal-yacht.yml";
import proposal from "./proposal.yml";
import rys from "./rys.yml";
import settings from "./settings.yml";
import subscription from "./subscription.yml";
import user from "./user.yml";
import video from "./video.yml";
import yachtFilter from "./yacht-filter.yml";
import yacht from "./yacht.yml";


export const I18N_RESOURCES = {
	admin,
	billing,
	brokerSearch,
	cabin,
	common,
	company,
	email,
	error,
	file,
	fleet,
	form,
	image,
	itineraryLocation,
	itineraryTemplate,
	location,
	nav,
	offer,
	place,
	proposal,
	proposalYacht,
	rys,
	settings,
	subscription,
	user,
	video,
	yacht,
	yachtFilter,
};
